import PageTemplate from "../templates/Template";
import Intern_PengelolaanTable from "./Intern_PengelolaanTable";
import React from "react";

const Intern_PengelolaanPage = (props) => {
    return(
    <PageTemplate title="Intern_Pengelolaan List">
        <Intern_PengelolaanTable/>
    </PageTemplate>)
}
export default Intern_PengelolaanPage;
